import script from "./ChatSettingsShowGroupUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettingsShowGroupUsers.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettingsShowGroupUsers.vue?vue&type=style&index=0&id=6cfb6f18&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfb6f18"]])

export default __exports__